// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import Tag, { TagProps } from "@insite/mobius/Tag";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React from "react";
import { css } from "styled-components";

interface TagVariants {
    contract?: TagProps;
    groupContract?: TagProps;
    Promotional?: TagProps;
    active?: TagProps;
}
const tagVariants: TagVariants = {
    contract: {
        deletable: false,
        css: css`
            border: none !important;
            outline: none;
            background-color: ${props => props.theme.colors.common.background};
            color: rgb(68, 51, 122);
            margin: 0;
            width: fit-content;
            align-items: center;
            min-height: 0;
            padding: 0.0625rem 0.25rem;
            border-radius: ${pxToRem(3)};
            outline: 1px ${getColor("text.contractPricing")} solid;
        `,
        typographyProps: {
            css: css`
                font-weight: 700;
                // need to use em because the font-size needs to scale with the different price font sizes
                font-size: 0.75em;
                margin: 0;
                white-space: nowrap;
                color: ${getColor("text.contractPricing")};
            `,
        },
    },
    active: {
        deletable: false,
        css: css`
            line-height: 16px;
            outline: none;
            background-color: ${getColor("common.background")};
            color: rgb(68, 51, 122);
            margin: 0;
            width: fit-content;
            align-items: center;
            min-height: 0;
            padding: 0.25rem 0.5rem;
            border-radius: ${pxToRem(3)};
            border: 1px ${getColor("success")} solid;
        `,
        typographyProps: {
            css: css`
                font-weight: 700;
                font-size: 1rem;
                margin: 0;
                white-space: nowrap;
                color: ${getColor("success")};
            `,
        },
    },
};

interface PromotionalTagStyles {
    tag?: InjectableCss;
    variants?: keyof TagVariants;
}
interface PromotionalTagProps {
    variant?: keyof TagVariants;
    tag: string;
}

const PromotionalTag: React.FC<PromotionalTagProps> = ({ tag, variant }) => {
    const tagVariantStyle = variant ? tagVariants[variant] : tagVariants.contract;
    // eslint-disable-next-line spire/avoid-dynamic-translate
    return <Tag {...tagVariantStyle}>{translate(tag).toUpperCase()}</Tag>;
};

export default PromotionalTag;
